import { getToken } from 'Arch/services/LocalStorageService';
import internals from '../config/internals';
import refleshToken from './RefleshToken';

export const isProdReturn = (prodOptiosn, otherOptions) => (process.env.NODE_ENV === 'production' ? prodOptiosn : otherOptions);

let isAlreadyFetchingAccessToken = false;

const httpConfig = (httpService, mockToken = null) => {
  httpService.interceptors.request.use(/* istanbul ignore next */ (config) => {
    const configure = config;
    if (!mockToken) {
      const token = getToken();
      if (token) {
        configure.headers.Authorization = `Bearer ${token}`;
      }
    } else {
      configure.headers.Authorization = `Bearer ${mockToken}`;
    }
    configure.headers.common['x-api-key'] = internals.x_api_key;
    return configure;
  });

  httpService.interceptors.response.use((res) => res, (err) => {
    if (err.response && err.response.status === 401) {
      if (!isAlreadyFetchingAccessToken) {
        isAlreadyFetchingAccessToken = true;
        refleshToken().finally(() => {
          isAlreadyFetchingAccessToken = false;
        });
      }
    }

    return Promise.reject(err);
  });
};

export default httpConfig;
